/*
 * Constant representing the headers for the lending table.
 */
const LENDINGS_TABLE_HEADERS = [
  'ldTblName',
  'ldTblStatus',
  'ldTblAdvance',
  'ldTblFunds',
  'ldTblRequestDate',
  'ldTblAmount',
  'ldTblDesAmount',
  'ldTblSettlementDate',
  'ldTblBill',
];

export default LENDINGS_TABLE_HEADERS;
